module.exports = __webpack_public_path__ + "static/img/261afc882ec14bd8bebc9e35a675259d.e2317444.png";